/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S1_Company_LabelInputs */

const tr_kullanim_s1_company_label = /** @type {(inputs: Kullanim_S1_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket Bilgileri:`)
};

const en_kullanim_s1_company_label = /** @type {(inputs: Kullanim_S1_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company details:`)
};

const de_kullanim_s1_company_label = /** @type {(inputs: Kullanim_S1_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensangaben:`)
};

const ru_kullanim_s1_company_label = /** @type {(inputs: Kullanim_S1_Company_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сведения о компании:`)
};

/**
* | output |
* | --- |
* | "Company details:" |
*
* @param {Kullanim_S1_Company_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s1_company_label = /** @type {((inputs?: Kullanim_S1_Company_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S1_Company_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s1_company_label(inputs)
	if (locale === "de") return de_kullanim_s1_company_label(inputs)
	if (locale === "ru") return ru_kullanim_s1_company_label(inputs)
	return tr_kullanim_s1_company_label(inputs)
});